var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDemoIconFigma({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.29639 0.544922H1.2753C1.23055 0.544921 1.18625 0.553733 1.14491 0.570856C1.10357 0.587979 1.066 0.613077 1.03437 0.644716C1.00273 0.676356 0.977628 0.713918 0.960505 0.755257C0.943382 0.796597 0.93457 0.840904 0.934571 0.885649V11.1129C0.934522 11.1577 0.943287 11.202 0.960366 11.2433C0.977445 11.2847 1.0025 11.3223 1.03411 11.354C1.06571 11.3856 1.10325 11.4108 1.14457 11.4279C1.18589 11.4451 1.23019 11.454 1.27493 11.454H2.29639C2.42505 11.454 2.55141 11.4199 2.66257 11.3551L11.2728 6.33547C11.3313 6.30105 11.3798 6.25194 11.4135 6.19301C11.4472 6.13407 11.4649 6.06736 11.4649 5.99947C11.4649 5.93158 11.4472 5.86486 11.4135 5.80593C11.3798 5.747 11.3313 5.69789 11.2728 5.66347L2.66257 0.643831C2.55141 0.579051 2.42505 0.544921 2.29639 0.544922Z",
    fill: "#147AF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemoIconFigma);
export default __webpack_public_path__ + "static/media/demo-icon-figma.c79d03d5046a93ec70f7f74acdda2f91.svg";
export { ForwardRef as ReactComponent };